import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useApiParameters } from "@/hooks/useApiParameters";
import { SettingsNavigation } from "@/routes/_auth/app/_app/settings/-components/SettingsNavigation";

export const Route = createFileRoute("/_auth/app/_app/settings")({
	loader: async ({ context }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);

		return { userId, token };
	},
	component: SettingsLayout,
});

function SettingsLayout() {
	const { t } = useTranslation();
	const location = useLocation();

	// Determine active tab based on current route
	const getActiveTab = () => {
		const pathname = location.pathname;
		if (pathname.includes("/admin-users")) return "admin-users";
		return "admin-users"; // default
	};

	return (
		<div className="flex flex-col h-full">
			{/* Page Header */}
			<div className="flex items-center gap-4 p-4 border-b border-base-300 bg-base-100">
				<div>
					<h1 className="text-lg font-semibold text-base-content">
						{t("settings.title", "Settings")}
					</h1>
					<p className="text-sm text-base-content/70">
						{t("settings.description", "Manage platform settings")}
					</p>
				</div>
			</div>

			{/* Main content area with side navigation */}
			<div
				className="flex-1 flex h-[calc(100vh-8rem)] min-h-0 overflow-hidden"
				data-testid="settings-container"
			>
				{/* Side Navigation */}
				<SettingsNavigation activeTab={getActiveTab()} />

				{/* Main Content Area */}
				<div
					className="flex-1 p-3 md:p-4 bg-base-200 min-h-0 overflow-auto"
					data-testid="settings-main-content-area"
				>
					<Outlet />
				</div>
			</div>
		</div>
	);
}
